import type { Hit } from '@algolia/client-search'
import type { TextProps } from '@components/primitives/Text'
import { Text } from '@components/primitives/Text'
import { classMerge } from '@components/utilities/classMerge'
import { Highlight } from 'react-instantsearch'

type HighlightedTextProps = {
  attribute: string
  hit: Hit<any>
} & Pick<TextProps, 'styleName' | 'color' | 'className'>

export default function HighlightedText({
  attribute,
  className,
  color = 'text-hope800',
  hit,
  styleName,
}: HighlightedTextProps) {
  /**
   * A bit of a hack to reformat the structure of this hit
   * @see https://www.algolia.com/doc/api-reference/widgets/highlight/react/#requirements
   */
  const highlightedHit = {
    _highlightResult: {
      [attribute]: {
        value: hit['highlighted'] ?? hit[attribute],
      },
    },
    ...hit,
  }
  return (
    <Text className={className} styleName={styleName}>
      <Highlight
        attribute={attribute}
        classNames={{
          highlighted: classMerge(color, 'bg-transparent'),
        }}
        hit={highlightedHit}
      />
    </Text>
  )
}
